<template>
  <div class="banner">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item) in imagesAttr" :key="item.id" @click="goUrl(item.linker)">
        <img class="img-item" v-lazy="item.file_url" />
        <!-- <img class="img-item" src="@/images/swiper_banner.png" /> -->
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import { Swipe, SwipeItem, Lazyload } from "vant";
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
export default {
  props: {
    bannerData: {
      type: Array
    }
  },
  data() {
    return {
      imagesAttr: []
    };
  },
  watch: {
    bannerData(val) {
      this.imagesAttr = val;
    }
  },
  created() {
    this.imagesAttr = this.bannerData;
  },
  methods: {
    //跳转轮播图处理
    goUrl(url) {
      this.$router.push(url);
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../../assets/stylus/index.styl';
@import '../../../assets/stylus/reset.css';

.banner {
  .van-swipe__indicators {
    align-items: center;
  }

  .van-swipe__indicator--active {
    width: 10px;
    height: 2px;
    border-radius: 2px;
  }
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  // line-height: 150px;
  text-align: center;

  .img-item {
    width: 100%;
    height: 222px;
  }
}
</style>